<button [ngClass]="buttonClasses()"
        [class.tw-w-full]="fullWidth()"
        [class.tw-opacity-50]="!actionable()"
        [class.tw-cursor-not-allowed]="!actionable()"
        [disabled]="!actionable()"
        [type]="type()"
        (click)="clicked.emit()">
  @if (loading()) {
    <app-spinner size="sm"
                 [strokeColorClass]="strokeClass()"/>
  } @else {
    <ng-content/>
    {{ label() }}
  }
</button>
